module.exports = __webpack_public_path__ + "img/sankaku_70_red.3be9f44b.png";